// import React, { useState, useEffect } from "react";
// import {
//   Table,
//   Button,
//   Modal,
//   Form,
//   Input,
//   InputNumber,
//   Space,
//   Popconfirm,
//   Row,
//   Col,
//   Tag,
//   Upload,
//   Switch,
//   Divider,
//   Typography,
//   Image,
//   TreeSelect,
//   Select,
// } from "antd";
// import {
//   PlusOutlined,
//   EditOutlined,
//   DeleteOutlined,
//   CloseCircleOutlined,
// } from "@ant-design/icons";
// import { categoryService, productService } from "../services";
// import { useApiEnhanced } from "../hooks/useApiEnhanced";
// import { toast } from "react-toastify";

// const { TextArea } = Input;
// const { Title } = Typography;
// const { Option } = Select;

// const ProductsSection = () => {
//   const {
//     data: productsList,
//     loading,
//     execute: refetchProducts,
//   } = useApiEnhanced(
//     () => productService.getProducts({ page: 1, limit: 100 }),
//     { immediate: true }
//   );

//   const { data: categoriesTree, loading: categoriesLoading } = useApiEnhanced(
//     () => categoryService.getCategoryTree(),
//     { immediate: true }
//   );

//   const { loading: creating, execute: createProduct } = useApiEnhanced(
//     (productData) => productService.createProduct(productData),
//     { immediate: false }
//   );

//   const { loading: editing, execute: editProduct } = useApiEnhanced(
//     (id, productData) => productService.updateProduct(id, productData),
//     { immediate: false }
//   );

//   const { loading: deleting, execute: deleteProduct } = useApiEnhanced(
//     (id) => productService.deleteProduct(id),
//     { immediate: false }
//   );

//   const [products, setProducts] = useState([]);
//   const [modalVisible, setModalVisible] = useState(false);
//   const [editingProduct, setEditingProduct] = useState(null);
//   const [existingImages, setExistingImages] = useState([]);
//   const [imagesToRemove, setImagesToRemove] = useState([]);
//   const [newImageFiles, setNewImageFiles] = useState([]);
//   const [previewImages, setPreviewImages] = useState([]);
//   const [form] = Form.useForm();

//   // Available sizes options
//   const availableSizes = [
//     "0-3M",
//     "3-6M",
//     "6-12M",
//     "6M",
//     "12M",
//     "18M",
//     "24M",
//     "2Y",
//     "3Y",
//     "4Y",
//     "5Y",
//     "6Y",
//     "7Y",
//     "8Y",
//     "9Y",
//     "10Y",
//     "11Y",
//     "12Y",
//     "13Y",
//     "14Y",
//     "S",
//     "M",
//     "L",
//     "XL",
//     "XXL",
//   ];

//   useEffect(() => {
//     if (!loading && productsList?.data) {
//       setProducts(productsList.data);
//     }
//   }, [loading, productsList]);

//   // Build category tree with full paths
//   const buildCategoryTreeData = (categories) => {
//     const buildNode = (category, parentPath = "") => {
//       const currentPath = parentPath
//         ? `${parentPath} > ${category.name}`
//         : category.name;

//       const children = category.children || [];

//       return {
//         title: currentPath,
//         value: category._id,
//         key: category._id,
//         children:
//           children.length > 0
//             ? children.map((child) => buildNode(child, currentPath))
//             : undefined,
//       };
//     };

//     return categories.map((cat) => buildNode(cat));
//   };

//   const handleMultipleImageUpload = (info) => {
//     const file = info.file.originFileObj || info.file;

//     if (!file) return;

//     // Add to new images
//     setNewImageFiles((prev) => [...prev, file]);

//     // Create preview
//     const reader = new FileReader();
//     reader.onload = (e) => {
//       setPreviewImages((prev) => [
//         ...prev,
//         {
//           url: e.target.result,
//           file: file,
//         },
//       ]);
//     };
//     reader.readAsDataURL(file);
//   };

//   const handleRemoveNewImage = (index) => {
//     setNewImageFiles((prev) => prev.filter((_, i) => i !== index));
//     setPreviewImages((prev) => prev.filter((_, i) => i !== index));
//   };

//   const handleRemoveExistingImage = (imageKey) => {
//     setImagesToRemove((prev) => [...prev, imageKey]);
//     setExistingImages((prev) => prev.filter((img) => img.key !== imageKey));
//     toast.success("Image marked for removal");
//   };

//   const columns = [
//     {
//       title: "Image",
//       dataIndex: "images",
//       key: "images",
//       render: (images) => (
//         <img
//           src={
//             images?.length > 0
//               ? images[0]?.url
//               : "https://via.placeholder.com/50"
//           }
//           alt="Product"
//           style={{ width: 50, height: 50, objectFit: "cover", borderRadius: 4 }}
//         />
//       ),
//     },
//     {
//       title: "Name",
//       dataIndex: "name",
//       key: "name",
//     },
//     {
//       title: "SKU",
//       dataIndex: "sku",
//       key: "sku",
//       render: (sku) => <Tag color="blue">{sku || "N/A"}</Tag>,
//     },
//     {
//       title: "Category",
//       dataIndex: "category",
//       key: "category",
//       render: (category) => category?.name || "-",
//     },
//     {
//       title: "Featured Category",
//       dataIndex: "featureCategoryProduct",
//       key: "featureCategoryProduct",
//       render: (featureCategoryProduct) =>
//         featureCategoryProduct?.name ? (
//           <Tag color="purple">{featureCategoryProduct.name}</Tag>
//         ) : (
//           "-"
//         ),
//     },
//     {
//       title: "Sizes",
//       dataIndex: "sizes",
//       key: "sizes",
//       render: (sizes) => (
//         <Space size={[0, 4]} wrap>
//           {sizes && sizes.length > 0 ? (
//             sizes.map((size, index) => (
//               <Tag key={index} color="cyan">
//                 {size}
//               </Tag>
//             ))
//           ) : (
//             <Tag>No sizes</Tag>
//           )}
//         </Space>
//       ),
//     },
//     {
//       title: "Price",
//       dataIndex: "price",
//       key: "price",
//       render: (price) => `₹${price}`,
//     },
//     {
//       title: "Stock",
//       dataIndex: "stock",
//       key: "stock",
//       render: (stock) => (
//         <Tag color={stock > 10 ? "green" : stock > 0 ? "orange" : "red"}>
//           {stock}
//         </Tag>
//       ),
//     },
//     {
//       title: "Tags",
//       key: "tags",
//       render: (_, record) => (
//         <Space size={[0, 8]} wrap>
//           {record.isNew && <Tag color="green">New</Tag>}
//           {record.isHotDeal && <Tag color="red">Hot Deal</Tag>}
//           {record.isFeatured && <Tag color="gold">Featured</Tag>}
//         </Space>
//       ),
//     },
//     {
//       title: "Status",
//       dataIndex: "status",
//       key: "status",
//       render: (status) => (
//         <Tag color={status === "Active" ? "green" : "red"}>{status}</Tag>
//       ),
//     },
//     {
//       title: "Actions",
//       key: "actions",
//       render: (_, record) => (
//         <Space>
//           <Button
//             icon={<EditOutlined />}
//             onClick={() => handleEdit(record)}
//             size="small"
//           >
//             Edit
//           </Button>
//           <Popconfirm
//             title="Are you sure you want to delete this product?"
//             onConfirm={() => handleDelete(record._id)}
//           >
//             <Button icon={<DeleteOutlined />} danger size="small">
//               Delete
//             </Button>
//           </Popconfirm>
//         </Space>
//       ),
//     },
//   ];

//   const handleEdit = (product) => {
//     setEditingProduct(product);
//     setExistingImages(product.images || []);
//     setImagesToRemove([]);
//     setNewImageFiles([]);
//     setPreviewImages([]);

//     form.setFieldsValue({
//       ...product,
//       category: product.category?._id,
//       featureCategoryProduct: product.featureCategoryProduct?._id,
//       sizes: product.sizes || [],
//     });
//     setModalVisible(true);
//   };

//   const handleDelete = async (id) => {
//     try {
//       let res = await deleteProduct(id);
//       if (!res?.success) return toast.error(res?.message);
//       await refetchProducts();
//       toast.success(res?.message || "Product deleted successfully");
//     } catch (error) {
//       return toast.error(
//         error?.response?.data?.message || "Failed to delete product"
//       );
//     }
//   };

//   const handleSubmit = async (values) => {
//     try {
//       const formData = new FormData();

//       formData.append("name", values.name);
//       formData.append("description", values.description || "");
//       formData.append("price", values.price);
//       formData.append("stock", values.stock);
//       formData.append("sku", values.sku || "");
//       formData.append("isNew", values.isNew || false);
//       formData.append("isHotDeal", values.isHotDeal || false);
//       formData.append("isFeatured", values.isFeatured || false);

//       // Category is required
//       if (!values.category) {
//         return toast.error("Please select a category");
//       }
//       formData.append("category", values.category);

//       // Featured Category is optional
//       if (values.featureCategoryProduct) {
//         formData.append(
//           "featureCategoryProduct",
//           values.featureCategoryProduct
//         );
//       }

//       // Add sizes
//       if (values.sizes && values.sizes.length > 0) {
//         console.log(typeof values?.sizes, values.sizes, "value sizes");
//         formData.append("sizes", JSON.stringify(values.sizes));
//       }

//       // Add new images
//       newImageFiles.forEach((file) => {
//         formData.append("images", file);
//       });

//       // Send images to remove
//       if (imagesToRemove.length > 0) {
//         formData.append("imagesToRemove", JSON.stringify(imagesToRemove));
//       }

//       let result;
//       if (editingProduct) {
//         result = await editProduct(editingProduct._id, formData);
//         if (!result?.success)
//           return toast.error(result?.message || "Something went wrong!");
//         toast.success("Product updated successfully");
//       } else {
//         result = await createProduct(formData);
//         if (!result?.success)
//           return toast.error(result?.message || "Something went wrong!");
//         toast.success("Product created successfully");
//       }

//       await refetchProducts();
//       handleModalClose();
//     } catch (error) {
//       console.error("Error saving product:", error);
//       toast.error(error.response?.data?.message || "Failed to save product");
//     }
//   };

//   const handleModalClose = () => {
//     setModalVisible(false);
//     form.resetFields();
//     setEditingProduct(null);
//     setExistingImages([]);
//     setImagesToRemove([]);
//     setNewImageFiles([]);
//     setPreviewImages([]);
//   };

//   return (
//     <div>
//       <div
//         style={{
//           marginBottom: 16,
//           display: "flex",
//           justifyContent: "space-between",
//         }}
//       >
//         <Title level={3}>Products Management</Title>
//         <Button
//           type="primary"
//           icon={<PlusOutlined />}
//           onClick={() => {
//             handleModalClose();
//             setModalVisible(true);
//           }}
//         >
//           Add Product
//         </Button>
//       </div>

//       <Table
//         columns={columns}
//         dataSource={products}
//         loading={loading}
//         rowKey="_id"
//         scroll={{ x: 1400 }}
//       />

//       <Modal
//         title={editingProduct ? "Edit Product" : "Add Product"}
//         visible={modalVisible}
//         onCancel={handleModalClose}
//         footer={null}
//         width={900}
//       >
//         <Form form={form} layout="vertical" onFinish={handleSubmit}>
//           <Row gutter={16}>
//             <Col span={12}>
//               <Form.Item
//                 name="name"
//                 label="Product Name"
//                 rules={[
//                   { required: true, message: "Please enter product name" },
//                 ]}
//               >
//                 <Input placeholder="Enter product name" />
//               </Form.Item>
//             </Col>
//             <Col span={12}>
//               <Form.Item
//                 name="sku"
//                 label="SKU"
//                 rules={[{ required: true, message: "Please enter SKU" }]}
//               >
//                 <Input placeholder="e.g., PROD-001" />
//               </Form.Item>
//             </Col>
//           </Row>

//           <Row gutter={16}>
//             <Col span={12}>
//               <Form.Item
//                 name="category"
//                 label="Category"
//                 rules={[
//                   { required: true, message: "Please select a category" },
//                 ]}
//                 tooltip="Required - Main product category"
//               >
//                 <TreeSelect
//                   showSearch
//                   placeholder="Select category *"
//                   allowClear
//                   treeDefaultExpandAll
//                   loading={categoriesLoading}
//                   treeData={
//                     categoriesTree?.success
//                       ? buildCategoryTreeData(categoriesTree.data)
//                       : []
//                   }
//                   filterTreeNode={(input, treeNode) =>
//                     treeNode.title.toLowerCase().includes(input.toLowerCase())
//                   }
//                 />
//               </Form.Item>
//             </Col>
//             <Col span={12}>
//               <Form.Item
//                 name="featureCategoryProduct"
//                 label="Featured Category"
//                 tooltip="Optional - Additional category to feature this product"
//               >
//                 <TreeSelect
//                   showSearch
//                   placeholder="Select featured category (optional)"
//                   allowClear
//                   treeDefaultExpandAll
//                   loading={categoriesLoading}
//                   treeData={
//                     categoriesTree?.success
//                       ? buildCategoryTreeData(categoriesTree.data)
//                       : []
//                   }
//                   filterTreeNode={(input, treeNode) =>
//                     treeNode.title.toLowerCase().includes(input.toLowerCase())
//                   }
//                 />
//               </Form.Item>
//             </Col>
//           </Row>

//           <Row gutter={16}>
//             <Col span={12}>
//               <Form.Item
//                 name="price"
//                 label="Price"
//                 rules={[{ required: true, message: "Please enter price" }]}
//               >
//                 <InputNumber
//                   style={{ width: "100%" }}
//                   placeholder="Enter price"
//                   min={0}
//                   prefix="₹"
//                 />
//               </Form.Item>
//             </Col>
//             <Col span={12}>
//               <Form.Item
//                 name="stock"
//                 label="Stock"
//                 rules={[{ required: true, message: "Please enter stock" }]}
//               >
//                 <InputNumber
//                   style={{ width: "100%" }}
//                   placeholder="Enter stock quantity"
//                   min={0}
//                 />
//               </Form.Item>
//             </Col>
//           </Row>

//           <Row gutter={16}>
//             <Col span={24}>
//               <Form.Item
//                 name="sizes"
//                 label="Available Sizes"
//                 rules={[
//                   {
//                     required: true,
//                     message: "Please select at least one size",
//                   },
//                 ]}
//               >
//                 <Select
//                   mode="multiple"
//                   placeholder="Select available sizes"
//                   style={{ width: "100%" }}
//                   optionFilterProp="children"
//                   filterOption={(input, option) =>
//                     option.children.toLowerCase().includes(input.toLowerCase())
//                   }
//                 >
//                   {availableSizes.map((size) => (
//                     <Option key={size} value={size}>
//                       {size}
//                     </Option>
//                   ))}
//                 </Select>
//               </Form.Item>
//             </Col>
//           </Row>

//           <Form.Item label="Product Images (Max 5)">
//             {/* Existing images */}
//             {editingProduct && existingImages.length > 0 && (
//               <div style={{ marginBottom: 16 }}>
//                 <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
//                   {existingImages.map((img, index) => (
//                     <div key={index} style={{ position: "relative" }}>
//                       <Image
//                         src={img.url}
//                         alt={`Product ${index + 1}`}
//                         style={{
//                           width: 100,
//                           height: 100,
//                           objectFit: "cover",
//                           borderRadius: 4,
//                         }}
//                       />
//                       <Button
//                         type="primary"
//                         danger
//                         size="small"
//                         icon={<CloseCircleOutlined />}
//                         style={{ position: "absolute", top: -8, right: -8 }}
//                         onClick={() => handleRemoveExistingImage(img.key)}
//                       />
//                     </div>
//                   ))}
//                 </div>
//                 <Divider />
//               </div>
//             )}

//             {/* New images preview */}
//             {previewImages.length > 0 && (
//               <div style={{ marginBottom: 16 }}>
//                 <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
//                   {previewImages.map((img, index) => (
//                     <div key={index} style={{ position: "relative" }}>
//                       <Image
//                         src={img.url}
//                         alt={`New ${index + 1}`}
//                         style={{
//                           width: 100,
//                           height: 100,
//                           objectFit: "cover",
//                           borderRadius: 4,
//                         }}
//                       />
//                       <Button
//                         type="primary"
//                         danger
//                         size="small"
//                         icon={<CloseCircleOutlined />}
//                         style={{ position: "absolute", top: -8, right: -8 }}
//                         onClick={() => handleRemoveNewImage(index)}
//                       />
//                     </div>
//                   ))}
//                 </div>
//                 <Divider />
//               </div>
//             )}

//             {/* Upload new images */}
//             {newImageFiles.length + existingImages.length < 5 && (
//               <Upload
//                 listType="picture-card"
//                 showUploadList={false}
//                 beforeUpload={() => false}
//                 onChange={handleMultipleImageUpload}
//               >
//                 <div>
//                   <PlusOutlined />
//                   <div style={{ marginTop: 8 }}>Upload Image</div>
//                 </div>
//               </Upload>
//             )}
//           </Form.Item>

//           <Form.Item label="Product Features">
//             <Row gutter={16}>
//               <Col span={8}>
//                 <Form.Item name="isNew" valuePropName="checked" noStyle>
//                   <Switch checkedChildren="New" unCheckedChildren="Not New" />
//                 </Form.Item>
//               </Col>
//               <Col span={8}>
//                 <Form.Item name="isHotDeal" valuePropName="checked" noStyle>
//                   <Switch
//                     checkedChildren="Hot Deal"
//                     unCheckedChildren="Regular"
//                   />
//                 </Form.Item>
//               </Col>
//               <Col span={8}>
//                 <Form.Item name="isFeatured" valuePropName="checked" noStyle>
//                   <Switch
//                     checkedChildren="Featured"
//                     unCheckedChildren="Standard"
//                   />
//                 </Form.Item>
//               </Col>
//             </Row>
//           </Form.Item>

//           <Form.Item name="description" label="Description">
//             <TextArea rows={4} placeholder="Enter product description" />
//           </Form.Item>

//           <Form.Item>
//             <Space>
//               <Button
//                 type="primary"
//                 htmlType="submit"
//                 loading={creating || editing}
//               >
//                 {editingProduct ? "Update Product" : "Add Product"}
//               </Button>
//               <Button onClick={handleModalClose}>Cancel</Button>
//             </Space>
//           </Form.Item>
//         </Form>
//       </Modal>
//     </div>
//   );
// };

// export default ProductsSection;

import React, { useState, useEffect } from "react";
import {
  Table,
  Button,
  Modal,
  Form,
  Input,
  InputNumber,
  Space,
  Popconfirm,
  Row,
  Col,
  Tag,
  Upload,
  Switch,
  Divider,
  Typography,
  Image,
  TreeSelect,
  Select,
} from "antd";
import {
  PlusOutlined,
  EditOutlined,
  DeleteOutlined,
  CloseCircleOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import { categoryService, productService, settingService } from "../services";
import { useApiEnhanced } from "../hooks/useApiEnhanced";
import { toast } from "react-toastify";

const { TextArea } = Input;
const { Title } = Typography;
const { Option } = Select;

const ProductsSection = () => {
  const {
    data: productsList,
    loading,
    execute: refetchProducts,
  } = useApiEnhanced(
    () => productService.getProducts({ page: 1, limit: 100 }),
    { immediate: true }
  );

  const { data: categoriesTree, loading: categoriesLoading } = useApiEnhanced(
    () => categoryService.getCategoryTree(),
    { immediate: true }
  );

  // Fetch settings for sizes
  const { data: settingsData, loading: settingsLoading } = useApiEnhanced(
    () => settingService.getSettings(),
    { immediate: true }
  );

  const { loading: creating, execute: createProduct } = useApiEnhanced(
    (productData) => productService.createProduct(productData),
    { immediate: false }
  );

  const { loading: editing, execute: editProduct } = useApiEnhanced(
    (id, productData) => productService.updateProduct(id, productData),
    { immediate: false }
  );

  const { loading: deleting, execute: deleteProduct } = useApiEnhanced(
    (id) => productService.deleteProduct(id),
    { immediate: false }
  );

  const [products, setProducts] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [modalVisible, setModalVisible] = useState(false);
  const [editingProduct, setEditingProduct] = useState(null);
  const [existingImages, setExistingImages] = useState([]);
  const [imagesToRemove, setImagesToRemove] = useState([]);
  const [newImageFiles, setNewImageFiles] = useState([]);
  const [previewImages, setPreviewImages] = useState([]);
  const [availableSizes, setAvailableSizes] = useState([]);
  const [form] = Form.useForm();

  // Fallback sizes if settings are not available
  const defaultSizes = [
    "0-3M",
    "3-6M",
    "6-12M",
    "6M",
    "12M",
    "18M",
    "24M",
    "2Y",
    "3Y",
    "4Y",
    "5Y",
    "6Y",
    "7Y",
    "8Y",
    "9Y",
    "10Y",
    "11Y",
    "12Y",
    "13Y",
    "14Y",
    "S",
    "M",
    "L",
    "XL",
    "XXL",
  ];

  useEffect(() => {
    if (!loading && productsList?.data) {
      setProducts(productsList.data);
    }
  }, [loading, productsList]);

  // Update available sizes from settings
  useEffect(() => {
    if (settingsData?.success && settingsData?.data?.sizes) {
      // Filter only active sizes
      const activeSizes = settingsData.data.sizes
        .filter((size) => size.isActive)
        .map((size) => ({
          value: size.value,
          label: size.label,
        }));

      setAvailableSizes(activeSizes);
    } else {
      // Use default sizes if settings not available
      const formattedDefaultSizes = defaultSizes.map((size) => ({
        value: size,
        label: size,
      }));
      setAvailableSizes(formattedDefaultSizes);
    }
  }, [settingsData]);

  // Build category tree with full paths
  const buildCategoryTreeData = (categories) => {
    const buildNode = (category, parentPath = "") => {
      const currentPath = parentPath
        ? `${parentPath} > ${category.name}`
        : category.name;

      const children = category.children || [];

      return {
        title: currentPath,
        value: category._id,
        key: category._id,
        children:
          children.length > 0
            ? children.map((child) => buildNode(child, currentPath))
            : undefined,
      };
    };

    return categories.map((cat) => buildNode(cat));
  };

  const handleMultipleImageUpload = (info) => {
    const file = info.file.originFileObj || info.file;

    if (!file) return;

    // Add to new images
    setNewImageFiles((prev) => [...prev, file]);

    // Create preview
    const reader = new FileReader();
    reader.onload = (e) => {
      setPreviewImages((prev) => [
        ...prev,
        {
          url: e.target.result,
          file: file,
        },
      ]);
    };
    reader.readAsDataURL(file);
  };

  const handleRemoveNewImage = (index) => {
    setNewImageFiles((prev) => prev.filter((_, i) => i !== index));
    setPreviewImages((prev) => prev.filter((_, i) => i !== index));
  };

  const handleRemoveExistingImage = (imageKey) => {
    setImagesToRemove((prev) => [...prev, imageKey]);
    setExistingImages((prev) => prev.filter((img) => img.key !== imageKey));
    toast.success("Image marked for removal");
  };

  const columns = [
    {
      title: "Image",
      dataIndex: "images",
      key: "images",
      render: (images) => (
        <img
          src={
            images?.length > 0
              ? images[0]?.url
              : "https://via.placeholder.com/50"
          }
          alt="Product"
          style={{ width: 50, height: 50, objectFit: "cover", borderRadius: 4 }}
        />
      ),
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "SKU",
      dataIndex: "sku",
      key: "sku",
      render: (sku) => <Tag color="blue">{sku || "N/A"}</Tag>,
    },
    {
      title: "Categories",
      key: "categories",
      render: (_, record) => (
        <Space size={[0, 4]} wrap>
          {record.categories && record.categories.length > 0 ? (
            record.categories.map((cat) => (
              <Tag key={cat._id} color="blue">
                {cat.name}
              </Tag>
            ))
          ) : record.category ? (
            <Tag color="blue">{record.category.name}</Tag>
          ) : (
            "-"
          )}
        </Space>
      ),
    },
    {
      title: "Featured Category",
      dataIndex: "featureCategoryProduct",
      key: "featureCategoryProduct",
      render: (featureCategoryProduct) =>
        featureCategoryProduct?.name ? (
          <Tag color="purple">{featureCategoryProduct.name}</Tag>
        ) : (
          "-"
        ),
    },
    {
      title: "Sizes",
      dataIndex: "sizes",
      key: "sizes",
      render: (sizes) => (
        <Space size={[0, 4]} wrap>
          {sizes && sizes.length > 0 ? (
            sizes.map((size, index) => (
              <Tag key={index} color="cyan">
                {size}
              </Tag>
            ))
          ) : (
            <Tag>No sizes</Tag>
          )}
        </Space>
      ),
    },
    {
      title: "Price",
      key: "price",
      render: (_, record) => (
        <Space direction="vertical" size={0}>
          <span style={{ fontWeight: 'bold' }}>₹{record.price}</span>
          {record.offerPrice && (
            <span style={{ color: 'green', fontSize: '12px' }}>
              Offer: ₹{record.offerPrice}
            </span>
          )}
        </Space>
      ),
    },
    {
      title: "Stock",
      dataIndex: "stock",
      key: "stock",
      render: (stock) => (
        <Tag color={stock > 10 ? "green" : stock > 0 ? "orange" : "red"}>
          {stock}
        </Tag>
      ),
    },
    {
      title: "Tags",
      key: "tags",
      render: (_, record) => (
        <Space size={[0, 8]} wrap>
          {record.isNew && <Tag color="green">New</Tag>}
          {record.isHotDeal && <Tag color="red">Hot Deal</Tag>}
          {record.isFeatured && <Tag color="gold">Featured</Tag>}
        </Space>
      ),
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (status) => (
        <Tag color={status === "Active" ? "green" : "red"}>{status}</Tag>
      ),
    },
    {
      title: "Actions",
      key: "actions",
      render: (_, record) => (
        <Space>
          <Button
            icon={<EditOutlined />}
            onClick={() => handleEdit(record)}
            size="small"
          >
            Edit
          </Button>
          <Popconfirm
            title="Are you sure you want to delete this product?"
            onConfirm={() => handleDelete(record._id)}
          >
            <Button icon={<DeleteOutlined />} danger size="small">
              Delete
            </Button>
          </Popconfirm>
        </Space>
      ),
    },
  ];

  const handleEdit = (product) => {
    setEditingProduct(product);
    setExistingImages(product.images || []);
    setImagesToRemove([]);
    setNewImageFiles([]);
    setPreviewImages([]);

    form.setFieldsValue({
      ...product,
      categories: product.categories?.map(cat => cat._id) || (product.category?._id ? [product.category._id] : []),
      featureCategoryProduct: product.featureCategoryProduct?._id || null,
      sizes: product.sizes || [],
      offerPrice: product.offerPrice || null,
    });
    setModalVisible(true);
  };

  const handleDelete = async (id) => {
    try {
      let res = await deleteProduct(id);
      if (!res?.success) return toast.error(res?.message);
      await refetchProducts();
      toast.success(res?.message || "Product deleted successfully");
    } catch (error) {
      return toast.error(
        error?.response?.data?.message || "Failed to delete product"
      );
    }
  };

  const handleAddProduct = () => {
    handleModalClose();

    // Pre-fill with all available sizes by default
    const defaultSelectedSizes = availableSizes.map((size) => size.value);

    form.setFieldsValue({
      sizes: defaultSelectedSizes,
    });

    setModalVisible(true);
  };

  const handleSubmit = async (values) => {
    try {
      const formData = new FormData();

      formData.append("name", values.name);
      formData.append("description", values.description || "");
      formData.append("price", values.price);
      formData.append("stock", values.stock);
      formData.append("sku", values.sku || "");
      formData.append("isNew", values.isNew || false);
      formData.append("isHotDeal", values.isHotDeal || false);
      formData.append("isFeatured", values.isFeatured || false);

      // Categories are required (multiple selection)
      if (!values.categories || values.categories.length === 0) {
        return toast.error("Please select at least one category");
      }
      formData.append("categories", JSON.stringify(values.categories));

      // Featured Category is optional and can be null
      if (values.featureCategoryProduct) {
        formData.append(
          "featureCategoryProduct",
          values.featureCategoryProduct
        );
      } else {
        formData.append("featureCategoryProduct", "");
      }

      // Offer Price is optional
      if (values.offerPrice) {
        formData.append("offerPrice", values.offerPrice);
      }

      // Add sizes
      if (values.sizes && values.sizes.length > 0) {
        console.log(typeof values?.sizes, values.sizes, "value sizes");
        formData.append("sizes", JSON.stringify(values.sizes));
      }

      // Add new images
      newImageFiles.forEach((file) => {
        formData.append("images", file);
      });

      // Send images to remove
      if (imagesToRemove.length > 0) {
        formData.append("imagesToRemove", JSON.stringify(imagesToRemove));
      }

      let result;
      if (editingProduct) {
        result = await editProduct(editingProduct._id, formData);
        if (!result?.success)
          return toast.error(result?.message || "Something went wrong!");
        toast.success("Product updated successfully");
      } else {
        result = await createProduct(formData);
        if (!result?.success)
          return toast.error(result?.message || "Something went wrong!");
        toast.success("Product created successfully");
      }

      await refetchProducts();
      handleModalClose();
    } catch (error) {
      console.error("Error saving product:", error);
      toast.error(error.response?.data?.message || "Failed to save product");
    }
  };

  const handleModalClose = () => {
    setModalVisible(false);
    form.resetFields();
    setEditingProduct(null);
    setExistingImages([]);
    setImagesToRemove([]);
    setNewImageFiles([]);
    setPreviewImages([]);
  };

  // Filter products based on search text
  const filteredProducts = products.filter((product) => {
    if (!searchText) return true;
    const searchLower = searchText.toLowerCase();
    const nameMatch = product.name?.toLowerCase().includes(searchLower);
    const skuMatch = product.sku?.toLowerCase().includes(searchLower);
    return nameMatch || skuMatch;
  });

  return (
    <div>
      <div
        style={{
          marginBottom: 16,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Title level={3}>Products Management</Title>
        <Space>
          <Input
            placeholder="Search by name or SKU"
            prefix={<SearchOutlined />}
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            allowClear
            style={{ width: 250 }}
          />
          <Button
            type="primary"
            icon={<PlusOutlined />}
            onClick={handleAddProduct}
          >
            Add Product
          </Button>
        </Space>
      </div>

      <Table
        columns={columns}
        dataSource={filteredProducts}
        loading={loading}
        rowKey="_id"
        scroll={{ x: 1400 }}
      />

      <Modal
        title={editingProduct ? "Edit Product" : "Add Product"}
        visible={modalVisible}
        onCancel={handleModalClose}
        footer={null}
        width={900}
      >
        <Form form={form} layout="vertical" onFinish={handleSubmit}>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="name"
                label="Product Name"
                rules={[
                  { required: true, message: "Please enter product name" },
                ]}
              >
                <Input placeholder="Enter product name" />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="sku"
                label="SKU"
                rules={[{ required: true, message: "Please enter SKU" }]}
              >
                <Input placeholder="e.g., PROD-001" />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="categories"
                label="Categories"
                rules={[
                  { required: true, message: "Please select at least one category" },
                ]}
                tooltip="Required - Select one or more product categories"
              >
                <TreeSelect
                  showSearch
                  placeholder="Select categories *"
                  allowClear
                  multiple
                  treeDefaultExpandAll
                  loading={categoriesLoading}
                  treeData={
                    categoriesTree?.success
                      ? buildCategoryTreeData(categoriesTree.data)
                      : []
                  }
                  filterTreeNode={(input, treeNode) =>
                    treeNode.title.toLowerCase().includes(input.toLowerCase())
                  }
                />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="featureCategoryProduct"
                label="Featured Category"
                tooltip="Optional - Additional category to feature this product"
              >
                <TreeSelect
                  showSearch
                  placeholder="Select featured category (optional)"
                  allowClear
                  treeDefaultExpandAll
                  loading={categoriesLoading}
                  treeData={
                    categoriesTree?.success
                      ? buildCategoryTreeData(categoriesTree.data)
                      : []
                  }
                  filterTreeNode={(input, treeNode) =>
                    treeNode.title.toLowerCase().includes(input.toLowerCase())
                  }
                />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={16}>
            <Col span={8}>
              <Form.Item
                name="price"
                label="Price"
                rules={[{ required: true, message: "Please enter price" }]}
              >
                <InputNumber
                  style={{ width: "100%" }}
                  placeholder="Enter price"
                  min={0}
                  prefix="₹"
                />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                name="offerPrice"
                label="Offer Price"
                tooltip="Optional - Discounted price"
              >
                <InputNumber
                  style={{ width: "100%" }}
                  placeholder="Enter offer price (optional)"
                  min={0}
                  prefix="₹"
                />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                name="stock"
                label="Stock"
                rules={[{ required: true, message: "Please enter stock" }]}
              >
                <InputNumber
                  style={{ width: "100%" }}
                  placeholder="Enter stock quantity"
                  min={0}
                />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={16}>
            <Col span={24}>
              <Form.Item
                name="sizes"
                label="Available Sizes"
                rules={[
                  {
                    required: true,
                    message: "Please select at least one size",
                  },
                ]}
                tooltip="Sizes are pre-selected from settings. You can remove any size by clicking the X"
              >
                <Select
                  mode="multiple"
                  placeholder="Select available sizes"
                  style={{ width: "100%" }}
                  optionFilterProp="children"
                  loading={settingsLoading}
                  filterOption={(input, option) =>
                    option.children.toLowerCase().includes(input.toLowerCase())
                  }
                  notFoundContent={
                    settingsLoading ? "Loading sizes..." : "No sizes available"
                  }
                >
                  {availableSizes.map((size) => (
                    <Option key={size.value} value={size.value}>
                      {size.label}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>

          <Form.Item label="Product Images (Max 5)">
            {/* Existing images */}
            {editingProduct && existingImages.length > 0 && (
              <div style={{ marginBottom: 16 }}>
                <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
                  {existingImages.map((img, index) => (
                    <div key={index} style={{ position: "relative" }}>
                      <Image
                        src={img.url}
                        alt={`Product ${index + 1}`}
                        style={{
                          width: 100,
                          height: 100,
                          objectFit: "cover",
                          borderRadius: 4,
                        }}
                      />
                      <Button
                        type="primary"
                        danger
                        size="small"
                        icon={<CloseCircleOutlined />}
                        style={{ position: "absolute", top: -8, right: -8 }}
                        onClick={() => handleRemoveExistingImage(img.key)}
                      />
                    </div>
                  ))}
                </div>
                <Divider />
              </div>
            )}

            {/* New images preview */}
            {previewImages.length > 0 && (
              <div style={{ marginBottom: 16 }}>
                <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
                  {previewImages.map((img, index) => (
                    <div key={index} style={{ position: "relative" }}>
                      <Image
                        src={img.url}
                        alt={`New ${index + 1}`}
                        style={{
                          width: 100,
                          height: 100,
                          objectFit: "cover",
                          borderRadius: 4,
                        }}
                      />
                      <Button
                        type="primary"
                        danger
                        size="small"
                        icon={<CloseCircleOutlined />}
                        style={{ position: "absolute", top: -8, right: -8 }}
                        onClick={() => handleRemoveNewImage(index)}
                      />
                    </div>
                  ))}
                </div>
                <Divider />
              </div>
            )}

            {/* Upload new images */}
            {newImageFiles.length + existingImages.length < 5 && (
              <Upload
                listType="picture-card"
                showUploadList={false}
                beforeUpload={() => false}
                onChange={handleMultipleImageUpload}
              >
                <div>
                  <PlusOutlined />
                  <div style={{ marginTop: 8 }}>Upload Image</div>
                </div>
              </Upload>
            )}
          </Form.Item>

          <Form.Item label="Product Features">
            <Row gutter={16}>
              <Col span={8}>
                <Form.Item name="isNew" valuePropName="checked" noStyle>
                  <Switch checkedChildren="New" unCheckedChildren="Not New" />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item name="isHotDeal" valuePropName="checked" noStyle>
                  <Switch
                    checkedChildren="Hot Deal"
                    unCheckedChildren="Regular"
                  />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item name="isFeatured" valuePropName="checked" noStyle>
                  <Switch
                    checkedChildren="Featured"
                    unCheckedChildren="Standard"
                  />
                </Form.Item>
              </Col>
            </Row>
          </Form.Item>

          <Form.Item name="description" label="Description">
            <TextArea rows={4} placeholder="Enter product description" />
          </Form.Item>

          <Form.Item>
            <Space>
              <Button
                type="primary"
                htmlType="submit"
                loading={creating || editing}
              >
                {editingProduct ? "Update Product" : "Add Product"}
              </Button>
              <Button onClick={handleModalClose}>Cancel</Button>
            </Space>
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default ProductsSection;
